import {
  AccountInfo,
  AuthError,
  IPublicClientApplication,
} from "@azure/msal-browser";

export const getScopes = (clientId: string): string[] => [
  "openid",
  "profile",
  "offline_access",
  `${clientId}/.default`,
];

export const acquireToken = async (
  account: AccountInfo,
  msalInstance: IPublicClientApplication,
  applicationId: string
): Promise<{ response: Awaited<ReturnType<IPublicClientApplication["acquireTokenSilent"]>> | void; silent: boolean }> => {
  const scopes = getScopes(applicationId);

  try {
    const response = await msalInstance.acquireTokenSilent({ scopes, account });
    return { response, silent: true };
  } catch (e) {
    if (e instanceof AuthError) {
      const response = await msalInstance.acquireTokenRedirect({ scopes, account });
      return { response, silent: false };
    }

    throw e;
  }
};

export const clearAuthStorage = (): void => {
  localStorage.removeItem("userToken");
  localStorage.removeItem("ImpersonationUserId");
};
